export default __webpack_public_path__ + "static/media/Corrado Augias.7a602fb2.jpg";